import {css, cva, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../../../../store/hooks";

interface IProps {
    className?: string;
    variant?: "small" | "large";
}

export function LeadModalPriceConversationConsultant(props: IProps) {
    const {className, variant = "large"} = props;
    const selectedConsultant = useAppSelector((state) => state.leadModal.consultant);

    if (!selectedConsultant) {
        return null;
    }

    const imageSize = variant === "small" ? 44 : 72;

    return (
        <div className={cx(consultantStyles({variant}), className)}>
            <Image
                src={selectedConsultant.image.s72}
                src2x={selectedConsultant.image.s144}
                src3x={selectedConsultant.image.s216}
                className={consultantImageStyles({variant})}
                width={`${imageSize}px`}
                height={`${imageSize}px`}
                alt={selectedConsultant.fullName}
            />
            <div className={consultantInfoStyles}>
                <Text variant="headline_6" as="span">
                    {selectedConsultant.fullName}
                </Text>
                <Text variant="body_copy_2" as="span">
                    Konsultant rynekpierwotny.pl
                </Text>
            </div>
        </div>
    );
}

// Styles
const consultantStyles = cva({
    base: {
        display: "flex",
        gap: 2,
        alignItems: "center",
        justifyContent: "center",
        background: "var(--colors-gray-100)",
        borderBottom: "1px solid var(--colors-gray-500)"
    },
    variants: {
        variant: {
            large: {
                padding: 2
            },
            small: {
                px: 2,
                py: 1
            }
        }
    }
});

const consultantImageStyles = cva({
    base: {
        borderRadius: "50%"
    },
    variants: {
        variant: {
            large: {
                flex: "0 1 72px"
            },
            small: {
                flex: "0 1 44px"
            }
        }
    }
});

const consultantInfoStyles = css({
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column"
});
import {css, cva, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../../../../store/hooks";

interface IProps {
    className?: string;
    variant?: "small" | "large";
}

export function LeadModalPriceConversationConsultant(props: IProps) {
    const {className, variant = "large"} = props;
    const selectedConsultant = useAppSelector((state) => state.leadModal.consultant);

    if (!selectedConsultant) {
        return null;
    }

    const imageSize = variant === "small" ? 44 : 72;

    return (
        <div className={cx(consultantStyles({variant}), className)}>
            <Image
                src={selectedConsultant.image.s72}
                src2x={selectedConsultant.image.s144}
                src3x={selectedConsultant.image.s216}
                className={consultantImageStyles({variant})}
                width={`${imageSize}px`}
                height={`${imageSize}px`}
                alt={selectedConsultant.fullName}
            />
            <div className={consultantInfoStyles}>
                <Text variant="headline_6" as="span">
                    {selectedConsultant.fullName}
                </Text>
                <Text variant="body_copy_2" as="span">
                    Konsultant rynekpierwotny.pl
                </Text>
            </div>
        </div>
    );
}

// Styles
const consultantStyles = cva({
    base: {
        display: "flex",
        gap: 2,
        alignItems: "center",
        justifyContent: "center",
        background: "var(--colors-gray-100)",
        borderBottom: "1px solid var(--colors-gray-500)"
    },
    variants: {
        variant: {
            large: {
                padding: 2
            },
            small: {
                px: 2,
                py: 1
            }
        }
    }
});

const consultantImageStyles = cva({
    base: {
        borderRadius: "50%"
    },
    variants: {
        variant: {
            large: {
                flex: "0 1 72px"
            },
            small: {
                flex: "0 1 44px"
            }
        }
    }
});

const consultantInfoStyles = css({
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column"
});
